/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AddOrUpdateReceiveAddressVo
 */
export interface AddOrUpdateReceiveAddressVo {
    /**
     * 收货地址ID
     * @type {number}
     * @memberof AddOrUpdateReceiveAddressVo
     */
    id?: number;
    /**
     * 用户id，对应user表的id
     * @type {number}
     * @memberof AddOrUpdateReceiveAddressVo
     */
    userId?: number;
    /**
     * 收件人姓名（韩文）
     * @type {string}
     * @memberof AddOrUpdateReceiveAddressVo
     */
    nameKr?: string;
    /**
     * 收件人姓名（英文）
     * @type {string}
     * @memberof AddOrUpdateReceiveAddressVo
     */
    nameEn?: string;
    /**
     * 收件人邮编
     * @type {string}
     * @memberof AddOrUpdateReceiveAddressVo
     */
    zip?: string;
    /**
     * 收件人地址
     * @type {string}
     * @memberof AddOrUpdateReceiveAddressVo
     */
    address?: string;
    /**
     * 收件人详细地址
     * @type {string}
     * @memberof AddOrUpdateReceiveAddressVo
     */
    addressDetail?: string;
    /**
     * 收件人电话
     * @type {string}
     * @memberof AddOrUpdateReceiveAddressVo
     */
    mobileNo?: string;
    /**
     * 个人还是企业 0 个人，1 企业
     * @type {number}
     * @memberof AddOrUpdateReceiveAddressVo
     */
    ctmsType?: number;
    /**
     * 个人或企业清关号
     * @type {string}
     * @memberof AddOrUpdateReceiveAddressVo
     */
    ctmsNo?: string;
    /**
     * 企业营业执照地址
     * @type {string}
     * @memberof AddOrUpdateReceiveAddressVo
     */
    businessLicenseAddress?: string;
}

/**
 * Check if a given object implements the AddOrUpdateReceiveAddressVo interface.
 */
export function instanceOfAddOrUpdateReceiveAddressVo(value: object): value is AddOrUpdateReceiveAddressVo {
    return true;
}

export function AddOrUpdateReceiveAddressVoFromJSON(json: any): AddOrUpdateReceiveAddressVo {
    return AddOrUpdateReceiveAddressVoFromJSONTyped(json, false);
}

export function AddOrUpdateReceiveAddressVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): AddOrUpdateReceiveAddressVo {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'userId': json['userId'] == null ? undefined : json['userId'],
        'nameKr': json['nameKr'] == null ? undefined : json['nameKr'],
        'nameEn': json['nameEn'] == null ? undefined : json['nameEn'],
        'zip': json['zip'] == null ? undefined : json['zip'],
        'address': json['address'] == null ? undefined : json['address'],
        'addressDetail': json['addressDetail'] == null ? undefined : json['addressDetail'],
        'mobileNo': json['mobileNo'] == null ? undefined : json['mobileNo'],
        'ctmsType': json['ctmsType'] == null ? undefined : json['ctmsType'],
        'ctmsNo': json['ctmsNo'] == null ? undefined : json['ctmsNo'],
        'businessLicenseAddress': json['businessLicenseAddress'] == null ? undefined : json['businessLicenseAddress'],
    };
}

export function AddOrUpdateReceiveAddressVoToJSON(json: any): AddOrUpdateReceiveAddressVo {
    return AddOrUpdateReceiveAddressVoToJSONTyped(json, false);
}

export function AddOrUpdateReceiveAddressVoToJSONTyped(value?: AddOrUpdateReceiveAddressVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'userId': value['userId'],
        'nameKr': value['nameKr'],
        'nameEn': value['nameEn'],
        'zip': value['zip'],
        'address': value['address'],
        'addressDetail': value['addressDetail'],
        'mobileNo': value['mobileNo'],
        'ctmsType': value['ctmsType'],
        'ctmsNo': value['ctmsNo'],
        'businessLicenseAddress': value['businessLicenseAddress'],
    };
}

